const API_BASE_URL = '/api';

class BagianService {
  getToken() {
    return localStorage.getItem('auth_token');
  }

  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const token = this.getToken();
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
      },
      ...options,
    };
    const response = await fetch(url, config);
    const data = await response.json();
    if (!response.ok) {
      // Auto-logout jika token expired
      if (response.status === 401 && data.error && data.error.includes('Token expired')) {
        window.dispatchEvent(new CustomEvent('auth:token-expired'));
      }
      throw new Error(data.error || `HTTP error! status: ${response.status}`);
    }
    return data;
  }

  async getPublicBagian() {
    const url = `${API_BASE_URL}/bagian/public`;
    const response = await fetch(url);
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || `HTTP error! status: ${response.status}`);
    return data;
  }

  async getBagian() {
    return this.request('/bagian');
  }

  async getAllBagian() {
    return this.request('/bagian/all');
  }

  async createBagian(data) {
    return this.request('/bagian', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async updateBagian(id, data) {
    return this.request(`/bagian/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async deleteBagian(id) {
    return this.request(`/bagian/${id}`, {
      method: 'DELETE',
    });
  }
}

export const bagianService = new BagianService();
export default bagianService;
